var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        "align-items": "flex-start"
      }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _vm.isTaskBlocked
            ? _c("management-button", {
                staticClass: "map-button",
                attrs: { type: "execute", label: _vm.$t("Show Message") },
                on: { buttonClick: _vm.showErrorMsg }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.taskDecisionButtons || _vm.isTaskBlocked
            ? _c("management-button", {
                staticClass: "map-button",
                attrs: {
                  type: "execute",
                  label: _vm.$t("Submit"),
                  disabled: _vm.taskDecisionButtons
                    ? _vm.taskContents.length !== _vm.tasks.length
                    : !(_vm.taskContents.length > 0)
                },
                on: { buttonClick: _vm.submit }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          class: _vm.isMixedTask ? "image-effect" : "image-effect ml-2",
          attrs: { wrap: "" }
        },
        [
          _vm._l(_vm.tasks, function(task) {
            return _c(
              "v-card",
              {
                key: task.id,
                class: _vm.isMixedTask
                  ? "mt-3 pa-2 elevation-2"
                  : "ma-3 pa-2 elevation-2",
                attrs: { width: "300", striped: "" },
                on: {
                  click: function($event) {
                    return _vm.openImageView(task)
                  }
                }
              },
              [
                task.value
                  ? _c("v-img", {
                      attrs: {
                        src: task.value,
                        alt: task.label,
                        "max-height": "200px",
                        width: "300px",
                        contain: "",
                        loading: "",
                        transition: "fade-transition"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-card-title",
                  [
                    _c(
                      "span",
                      [
                        task.blocked
                          ? _c("v-icon", { attrs: { color: "error" } }, [
                              _vm._v("\n            priority_high\n          ")
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n          " + _vm._s(task.label) + "\n        "
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.taskDecisionButtons || _vm.isTaskBlocked
                      ? _c("task-decision-buttons", {
                          attrs: {
                            isTaskBlocked: _vm.isTaskBlocked,
                            uuid: task.uuid,
                            taskContents: _vm.taskContents
                          },
                          on: {
                            approve: function($event) {
                              return _vm.$emit("updateTaskContents", {
                                decision: "approve",
                                uuid: task.uuid
                              })
                            },
                            reject: function($event) {
                              return _vm.$emit("updateTaskContents", {
                                decision: "reject",
                                uuid: task.uuid
                              })
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.imageData
            ? _c("photo-view", {
                attrs: {
                  dialog: _vm.dialog,
                  imageData: _vm.imageData,
                  taskContents: _vm.taskContents,
                  taskDecisionButtons: _vm.taskDecisionButtons
                },
                on: {
                  close: function($event) {
                    return _vm.closeImageView($event)
                  },
                  updateTaskContents: function($event) {
                    return _vm.$emit("updateTaskContents", $event)
                  }
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("text-message", {
        attrs: { textDialog: _vm.textDialog, text: _vm.textMsg },
        on: { closeTextDialog: _vm.closeTextDialog }
      }),
      _vm._v(" "),
      _c(
        "app-dialog-box",
        {
          attrs: {
            open: _vm.rejectDialog,
            title: _vm.$t("RejectTask"),
            content: _vm.$t("RejectionMessage") + "*",
            "main-action-label": _vm.$t("Cancel"),
            "secondary-action-label": _vm.$t("Reject"),
            "secondary-action-disable":
              _vm.rejectionMessage.trim().length !== 0,
            loading: _vm.loadingDelete
          },
          on: {
            mainAction: _vm.cancelRejection,
            secondaryAction: _vm.rejectTask
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "rejection-message-textarea",
              attrs: { slot: "dialog-textbox" },
              slot: "dialog-textbox"
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rejectionMessage,
                    expression: "rejectionMessage"
                  }
                ],
                staticClass: "input-field",
                attrs: { maxlength: "1024" },
                domProps: { value: _vm.rejectionMessage },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.rejectionMessage = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v(_vm._s(_vm.$t("RejectionNote")))])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ceba9dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ceba9dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldManagement/FieldWork/Data/TaskType/Photos.vue
// module id = null
// module chunks = 